import makeRequest from "./makeRequest";
import getRuntimeConstants from "../runtimeConstants";
import getWindow from "../utils/window";

export type ReturnNotesSummary = {
  summary: string;
  disclaimer: string;
  version: number;
};

const getSiteOrigin = () =>
  new URLSearchParams(getWindow()?.location?.search ?? "").get("x-site-origin");

export default async function getReturnNotesSummary() {
  const {
    webContext: { browseLanguage, storeId },
    product: { id: productId },
    returnNotesSummary: {
      returnNotesSummaryApiPath,
      returnNotesSummaryApiTimeout,
    },
  } = getRuntimeConstants();

  const url = returnNotesSummaryApiPath.replace("{id}", productId);
  const browseLocale = browseLanguage?.split("-")?.[0] ?? browseLanguage;

  const params: Record<string, string> = {
    store: storeId,
    lang: browseLocale,
  };

  const siteOrigin = getSiteOrigin();

  if (siteOrigin) {
    params["x-site-origin"] = siteOrigin;
  }

  const mapData = (
    data: ReturnNotesSummary,
    _headers: unknown,
    status?: number,
  ) => {
    if (status === 404) {
      return null;
    }

    const { summary, disclaimer, version } = data;
    return { summary, disclaimer, version };
  };

  const validateStatus = (status: number) =>
    status === 404 || (status >= 200 && status < 300);

  return makeRequest({
    url,
    params,
    timeout: returnNotesSummaryApiTimeout,
    headers: undefined,
    body: undefined,
    requestType: "RETURN_NOTES_API",
    apiName: "Return Notes",
    caller: "Return Notes Summary",
    mapData,
    validateStatus,
  });
}
